import React from 'react';
import FormCreateMoneyReport from '../../../../molecules/Form/FormCreateMoneyReport';

const Screen = () => {
  return (
    <>
      <div className="h-full w-full flex justify-center items-center">
        <div className="w-[70%] h-auto m-6 rounded-lg bg-gray-100 flex flex-col items-center">
          <h1 className='center mt-6 font-bold text-xl'>Money Report</h1>
          <div className="form-group">
            <FormCreateMoneyReport />
          </div>
        </div>
      </div>
    </>
  )
}

export default Screen;